/** Telefon numarası yardımcıları — E.164 ve eski TR formatları birlikte çalışsın. */

// WhatsApp wa.me bağlantısı için uluslararası rakam dizisi döndürür.
// "+905321234567" → "905321234567" · "05321234567" → "905321234567" · "5321234567" → "905321234567"
export function toWaDigits(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (String(raw).trim().startsWith("+")) return digits;
  if (digits.startsWith("90") && digits.length >= 12) return digits;
  if (digits.startsWith("0")) return `90${digits.slice(1)}`;
  if (digits.length === 10) return `90${digits}`;
  return digits;
}

export function waLink(raw, text) {
  const digits = toWaDigits(raw);
  const q = text ? `?text=${encodeURIComponent(text)}` : "";
  return digits ? `https://wa.me/${digits}${q}` : `https://wa.me/${q}`;
}
